import React from "react";
// import Grid from "@material-ui/core/Grid";
import "./Thankyou.css";
// import { useTranslation } from "react-i18next";
import { thankYouImage1, thankYouImage2 } from "../../images/images";
import { isNewUI } from "../../utils/handleProgress";
import ThankYouNew from "../POSV_New_Ui/ThankYouNew/ThankYouNew";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { doneImg } from "../../images/TeleBindingImages/TeleBindingImages";
import { CAPS_Y } from "../../utils/constants";

const Thankyou = (props) => {
  // const { t } = useTranslation();
const location = useLocation();
const fromPayment = sessionStorage.getItem("isTelebinding") === CAPS_Y;

  window.scrollTo(0, 0);
  props.history.listen((location, action) => {
    if (action === "POP") {
      props.history.push("/thankyou");
    }
  });

  return (
    <>
      {
        isNewUI() && !fromPayment ? (
          <ThankYouNew />
        ) : 
          fromPayment ? (
      <div className="payment-thanks-container">
        <div className="payment-thanks-image">
          <img src={doneImg} alt="Payment Complete" />
        </div>

        <div className="payment-thanks-text">
          <h2 className="payment-done-text">All Steps Done!</h2>
          <p className="payment-status-msg">
            We’ll update you on your verification <br /> status within 24 hours.
          </p>
        </div>
      </div>
    ) : (
        
          <div className="thanks-container">

            <div className="thanksImage1_container">
              <img src={thankYouImage1} alt={"Thank"} className="thanksImage1" />
            </div>

            <div className="done_text_container">
              <p>Its done!</p>
            </div>

            <div className="main_text-1">
              <p>

                Your Pre-Issuance Verification has been
                completed successfully!
              </p>

              <p>We’ll send you an email confirmation shortly.</p>
            </div>

            <div className="thanksImage2_container">
              <img src={thankYouImage2} alt={"Thanks"} className="thanksImage2" />
            </div>

          </div>
    )
      }
    </>

  );
};

export default Thankyou;
